export enum DateFilterType {
  FixedPeriod = 'FixedPeriod',
  MonthsRange = 'MonthsRange',
  DatesRange = 'DatesRange',
}
